import React from 'react';
import { useManageLogs } from '../contexts/manage-logs.context';
import { Button, Icon, Row, Table } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { TPlatformUserTermItem } from '../hooks/usePlatformUserTermSearch/type';
import { Tooltip } from '@extend/antd/tooltip';
import { Drawer } from '@extend/antd/drawer';
import { LongTextTd } from 'o2o_layout';

const TableDataPrivacyLogs = () => {
  const { searchPlatformTermUser } = useManageLogs();
  const { isLoading, response } = searchPlatformTermUser;

  const { openViewJSON } = Drawer.useDrawerViewJSON();

  const columns: ColumnProps<{}>[] = [
    {
      title: '#',
      key: 'index',
      sorter: false,
      align: 'center',
      width: 25,
      render: (text: any, record: TPlatformUserTermItem, index: number) => {
        return index + 1;
      },
    },
    {
      title: 'Id',
      key: 'id',
      sorter: false,
      ellipsis: true,
      width: 100,
      render: (text: any, record: TPlatformUserTermItem, index: number) => {
        return <LongTextTd text={record.id} />;
      },
    },
    {
      title: 'User',
      key: 'userId',
      sorter: false,
      ellipsis: true,
      width: 60,
      render: (text: any, record: TPlatformUserTermItem, index: number) => {
        return <LongTextTd text={record.userId} />;
      },
    },
    {
      title: 'Updated Term',
      key: 'UpdatedAt',
      sorter: false,
      ellipsis: true,
      align: 'center',
      width: 80,
      render: (text: any, record: TPlatformUserTermItem, index: number) => {
        return record?.active ? (
          <Icon type="check-circle" style={{ color: 'var(--primary-color)' }} />
        ) : (
          <Icon type="check-circle" />
        );
      },
    },
    {
      title: 'Updated At',
      key: 'UpdatedAt',
      sorter: false,
      ellipsis: true,
      width: 140,
      render: (text: any, record: TPlatformUserTermItem, index: number) => {
        return (
          <Tooltip.Date
            date={record.updatedAt}
            prefix_tooltip={`Updated by ${record?.updatedBy} at`}
            format="DD_MM_YYYY_HH_MM_SS"
          />
        );
      },
    },
    {
      title: 'Action',
      key: 'action',
      sorter: false,
      ellipsis: true,
      align: 'center',
      fixed: 'right',
      width: 60,
      render: (text: any, record: any, index: number) => {
        return (
          <Row type="flex" align="middle" justify="center">
            <Tooltip title="View JSON">
              <Button size="small" type="link" onClick={() => openViewJSON({ data: record })} icon="select" />
            </Tooltip>
          </Row>
        );
      },
    },
  ];

  return (
    <Table
      rowKey="id"
      size="small"
      loading={isLoading}
      columns={columns}
      pagination={false}
      dataSource={response?.results?.content}
      className="mt10"
      scroll={{ x: 'calc(100px + 50%)' }}
    />
  );
};

export default TableDataPrivacyLogs;
